import Tables from 'src/class/Tables';
import i18n from 'src/i18n';

const depthProperty = (depth) =>
  `depth_${String(depth).replace(/[^a-zA-Z0-9]/g, '_')}`;

const baseColumns = () => [
  {
    prop: 'date',
    label: i18n.t('common_words.date'),
    minWidth: 115,
    sortable: true,
    align: 'center',
  },
  {
    prop: 'farm',
    label: i18n.t('common_words.farm'),
    minWidth: 160,
    sortable: true,
    align: 'center',
  },
  {
    prop: 'user',
    label: i18n.t('common_words.user'),
    minWidth: 150,
    sortable: true,
    align: 'center',
  },
  {
    prop: 'section',
    label: i18n.t('common_words.section'),
    minWidth: 140,
    sortable: true,
    align: 'center',
  },
  {
    prop: 'block',
    label: i18n.t('irrigation.block'),
    minWidth: 110,
    sortable: true,
    align: 'center',
  },
  {
    prop: 'variety',
    label: i18n.t('common_words.variety'),
    minWidth: 150,
    sortable: true,
    align: 'center',
  },
  {
    prop: 'bed',
    label: i18n.t('common_words.bed'),
    minWidth: 110,
    sortable: true,
    align: 'center',
  },
];

const configTable = (reportType = 'detailed', depths = []) => {
  const Table = { ...Tables.Table };

  if (reportType === 'detailed') {
    Table.tableColumns = baseColumns().concat([
      {
        prop: 'blood_pressure_monitor',
        label: i18n.t('devices.blood_pressure_monitors'),
        minWidth: 160,
        sortable: true,
        align: 'center',
      },
      {
        prop: 'valve',
        label: i18n.t('common_words.valve'),
        minWidth: 110,
        sortable: true,
        align: 'center',
      },
      {
        prop: 'depth',
        label: i18n.t('common_words.depth'),
        minWidth: 130,
        sortable: true,
        align: 'center',
      },
      {
        prop: 'value',
        label: `${i18n.t('common_words.value')} (kPa)`,
        minWidth: 130,
        sortable: true,
        align: 'center',
      },
    ]);
  } else {
    Table.tableColumns = baseColumns()
      .concat([
        {
          prop: 'valve',
          label: i18n.t('common_words.valve'),
          minWidth: 110,
          sortable: true,
          align: 'center',
        },
      ])
      .concat(
        depths.map((depth) => ({
          label: `${i18n.t('common_words.depth')} ${depth}`,
          minWidth: 130,
          align: 'center',
          children: [
            {
              prop: depthProperty(depth),
              label: `${i18n.t('common_words.value')} (kPa)`,
              minWidth: 130,
              sortable: true,
              align: 'center',
            },
          ],
        }))
      );
  }

  return { Table };
};

export { depthProperty };
export default configTable;
